import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "styled-components";

import { VideoPlayerButton } from "./VideoPlayerButton.styles";

/**
 * Create Image button
 * @component
 * @param {Object} props
 */

const VideoPlayerButtonComponent = React.forwardRef((props, ref) => {
  const {
    alt,
    theme,
    src,
    onClickHandler,
    testID,
    buttonName,
    onKeyHandler,
    tabIndex,
    onKeyDownHandler,
    disabled,
    tooltipDirection,
    tooltipHorizontalDirection,
    $hoverBackgroundColor,
    $disableHoverEffect,
    buttonClassName,
  } = props;
  return (
    <VideoPlayerButton
      data-testid={testID}
      type="button"
      theme={theme}
      onClick={onClickHandler}
      onKeyUp={onKeyHandler}
      ref={ref}
      tabIndex={tabIndex}
      onKeyDown={onKeyDownHandler}
      disabled={disabled}
      $hoverBackgroundColor={$hoverBackgroundColor}
      $disableHoverEffect={$disableHoverEffect}
      className={buttonClassName}
    >
      <img alt={alt} src={src} />

      {alt && tooltipDirection && (
        <span className={`${tooltipDirection}  ${tooltipHorizontalDirection}   btn-tooltip`}>{alt}</span>
      )}

      {buttonName && <span className="button-name">{buttonName}</span>}
    </VideoPlayerButton>
  );
});

VideoPlayerButtonComponent.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func,
  onKeyHandler: PropTypes.func,
  testID: PropTypes.string,
  buttonName: PropTypes.string,
  buttonContainerStyles: PropTypes.string,
  onKeyDownHandler: PropTypes.func,
  disabled: PropTypes.bool,
};
VideoPlayerButtonComponent.defaultProps = {
  onClickHandler: (e) => e,
  buttonName: null,
  buttonContainerStyles: "",
  onKeyDownHandler: (e) => e,
  disabled: false,
};

export default VideoPlayerButtonComponent;
